import React, {useMemo} from "react";
import {CatalogArticle, CatalogArticleAnalogue} from "../../../../models/articles/catalog/search";
import {Pagination} from "../../../../models/requests/paginated-result/paginated.result";
import {useTranslation} from "react-i18next";
import {ColumnsType} from "antd/es/table";
import {Space, Table} from "antd";
import {Amount} from "../../../../models/amount/amount";
import {Link} from "react-router-dom";
import {Price} from "../../../core/commons/price/price";
import {AddToCartAction} from "../../ui/button/add-to-cart-action/add-to-cart-action";
import {AddToWishlistAction} from "../../ui/button/add-to-wishlist-action/add-to-cart-action";

interface CatalogCartsViewProps {
    strictItems: CatalogArticle[];
    items: CatalogArticle[];
    pagination: Pagination;
    onPageChange: (page: number, size: number) => void;
}

export const CatalogTableView: React.FC<CatalogCartsViewProps> = ({items, strictItems, pagination, onPageChange}) => {

    const {t} = useTranslation("translation", {useSuspense: false});

    const warehouses = useMemo(() => {
        const result = new Set<string>();
        [...items, ...strictItems].forEach(item => item.stock.forEach(stockItem => result.add(stockItem.warehouse)))
        return result;
    }, [items, strictItems])

    const columns: ColumnsType<CatalogArticle> = [
        {
            title: t("ARTICLES.TITLE_SINGLE"),
            dataIndex: "name",
            key: "name",
            width: "100px",
            render: (item: string) => <span style={{whiteSpace: "nowrap"}}>{item}</span>
        },
        {
            title: t("ARTICLES.NAME"),
            dataIndex: "description",
            key: "description",
            className: "catalog-table-description",
            render: (item: string, row: CatalogArticle) => <Link className="link" to={"catalog/article/" + row.name}>{item}</Link>
        },
        {
            title: t("PRICE"),
            dataIndex: "amount",
            key: "amount",
            render: (price: Amount) => <Price value={price} />
        },
    ];

    warehouses.forEach(warehouse => {
        columns.push({
            title: warehouse,
            dataIndex: warehouse,
            key: warehouse,
            render: (_: any, row: CatalogArticle) => {
                const foundWarehouse = row.stock.find(item => item.warehouse === warehouse);
                return foundWarehouse ? foundWarehouse.amount : "0";
            }
        });
    });

    columns.push(...[
        {
            title: t("ARTICLES.COMPATIBLE_OEM"),
            dataIndex: "analogues",
            key: "analogues",
            render: (item: CatalogArticleAnalogue[]) => item.length ? <><span style={{fontWeight: "bold"}}>{item[0].brand}</span>: { item[0].name}</> : null
        },
        {
            title: "",
            key: "actions",
            width: "100px",
            className: "catalog-table-btn",
            render: (_: any, row: CatalogArticle) => (
                <Space direction={"horizontal"} size={[20, 20]}>
                    <AddToCartAction article={row} />
                    <AddToWishlistAction article={row} />
                </Space>

            )
        }
        ]);

    return (
        <div className="catalog_view_table_container">
            <Table
                columns={columns}
                rowKey={"id"}
                dataSource={[...strictItems, ...items]}
                scroll={{x: true}}
                pagination={{
                    position: ["bottomRight"],
                    total: pagination?.total,
                    current: pagination?.page,
                    pageSize: pagination?.limit,
                    showQuickJumper: true,
                    onChange: onPageChange,
                    showTotal: (total) => "Total items: " + total
                }}
            />
        </div>
    );
}